import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { RuntimeConfig } from './config';

/**
 * supabase-js is used for AUTH ONLY. It appends /auth/v1 to the base URL, which is exactly the path
 * Caddy proxies to Kong on the portal host. Data reads will go through PostgREST at /rest/v1 later;
 * the shell has no data screen and must not pretend otherwise.
 */
export function createSupabaseClient(config: RuntimeConfig): SupabaseClient {
  return createClient(config.apiBaseUrl, config.anonKey, {
    auth: {
      // The session survives a reload; without this every refresh is a new sign-in.
      persistSession: true,
      autoRefreshToken: true,
      // PKCE (login CSRF, design section 2): a sign-in link comes back as `?code=`, which only the
      // browser that asked for the link can exchange (it holds the code verifier). A link someone else
      // crafted cannot sign this browser into his account. AuthProvider does the exchange itself, on
      // /signin and /invite/<id> only (lib/authLink.ts); detectSessionInUrl stays off so auth-js never
      // reads the URL on its own, least of all implicit-flow tokens in the fragment.
      flowType: 'pkce',
      detectSessionInUrl: false,
      storageKey: 'coreway.auth',
    },
  });
}
